<h2 mat-dialog-title>
	Dictation Menu
</h2>

<mat-dialog-content>
	<p>
		<strong>Select note section</strong>
	</p>

	<mat-form-field class="noteSelect">
		<mat-label>Note Section</mat-label>
		<mat-select [(ngModel)]="selectedNoteSection" [disabled]="hasStarted">
			@for (option of options; track option) {
				<mat-option [value]="option">{{ option }}</mat-option>
			}
		</mat-select>
	</mat-form-field>

	@switch (state) {
		@case (RecordingStates.Initial) {
			<div class="recording-container">
				<button class="recording-circle" mat-ripple [disabled]="selectedNoteSection == null" (click)="startMic()">
					<mat-icon [inline]="true">mic</mat-icon>
				</button>
			</div>
		}
		@case (RecordingStates.Recording) {
			<div class="recording-time pink">
				<mat-icon class="filled">circle</mat-icon>
				<span>{{ recordingTime | date : 'mm:ss' }}</span>
			</div>

			<button class="big-pink-button" mat-ripple (preventDoubleClick)="pauseMic()">
				<mat-icon>pause</mat-icon>
				<span>Pause dictation</span>
			</button>
			<button class="big-pink-text-button" mat-ripple (preventDoubleClick)="stopMic()">
				End dictation
			</button>
		}
		@case (RecordingStates.Waiting) {
			<div class="recording-time">
				<span>{{ recordingTime | date : 'mm:ss' }}</span>
			</div>

			<button class="big-blue-button" mat-ripple (click)="startMic()">
				<mat-icon>resume</mat-icon>
				<span>Resume dictation</span>
			</button>

			<button class="big-blue-text-button" mat-ripple (click)="stopMic()">
				End dictation
			</button>
		}
		@case (RecordingStates.Paused) {
			<div class="recording-time">
				<span>{{ recordingTime | date : 'mm:ss' }}</span>
			</div>

			<button class="big-blue-button" mat-ripple (click)="resumeMic()">
				<mat-icon>resume</mat-icon>
				<span>Resume dictation</span>
			</button>

			<button class="big-blue-text-button" mat-ripple (click)="stopMic()">
				End dictation
			</button>
		}
		@case (RecordingStates.Unsupported) {
			<div class="error">Unfortunately, it seems like your device doesn't support audio input.</div>
		}
		@case (RecordingStates.NoDevices) {
			<div class="error">Microphone access is currently unavailable. Please ensure it's enabled in your device settings.
			</div>
		}
		@case (RecordingStates.MicDeclined) {
			<div class="error">It looks like you declined mic access, please refresh the page and try again.</div>
		}
		@case (RecordingStates.Error) {
			<div class="error">It looks like there was an error, check log for details.</div>
		}
	}

</mat-dialog-content>

<mat-dialog-actions>
	<button mat-button cdkFocusInitial class="close" (click)="closeDialog()">Cancel</button>
</mat-dialog-actions>
